<div class="p-6 flex h-full w-full justify-center items-center">
  <div class="rounded-lg bg-gradient-to-b from-purple-200 to-blue-200 p-16">
    <div class="w-auto max-w-[650px] flex items-center flex-col gap-6 min-w-96 border rounded-md border-gray-medium shadow-sm bg-white p-16">
      <div class="font-bold text-9xl text-center w-96">
        <span class="text-theme-primary">4</span>
        <span class="text-teal-500">0</span>
        <span class="text-yellow-500">1</span>
      </div>
      <div class="flex flex-col gap-4 items-center">
        <div class="text-gray-700 text-center">{{ 'error.401.title' | translate }}</div>
        <div class="text-sm text-slate-400 text-center">{{ 'error.401.description' | translate }}</div>
      </div>
      <div>
        <button appButton (click)="login()">
          {{ 'common.auth.login' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
